import logo from "../../images/suplink.jpg";

import styles from "./Logo.module.css";

const Logo = () => {
  return (
    <div className={styles.header_container}>
      <img alt="suuplink logo" src={logo} width={300} height="auto" />
    </div>
  );
};

export default Logo;
